export { NAV_HEIGHT as TOP_NAV_HEIGHT } from 'Layout/MyAccountLayout/dimensions';
export const LEFT_MENU_WIDTH = 215;
export const NAV_MENU_HEIGHT = 95;
export const NAV_MENU_HEIGHT_EDITOR = 60;
export const IMAGE_PADDING = 20;
export const CONTENT_PADDING_TOP = 48;
export const CONTENT_PADDING_LEFT = 20;
export const CONTENT_PADDING_RIGHT = 15;

export const CONNECTOR_PATH = '/allimages/core/connector/php/connector.php';

export const DELETE_FOLDER_DIALOG = 'deleteFolder';
export const NEW_FOLDER_DIALOG = 'newFolder';
export const RENAME_FOLDER_DIALOG = 'renameFolder';
export const DELETE_IMAGE_DIALOG = 'deleteImage';
export const EDIT_INFO_IMAGE_DIALOG = 'infoImage';
export const UPLOAD_IMAGE_FROM_URL = 'uploadImageFromUrl';
export const ERROR_IMAGE_DIALOG = 'errorImage';

export const ERROR_FILE_UPLOAD_STATUS = 'error';
export const CANCELED_FILE_UPLOAD_STATUS = 'canceled';
export const UPLOADED_FILE_UPLOAD_STATUS = 'uploaded';
export const LOADING_FILE_UPLOAD_STATUS = 'loading';

export const SORT_DIRECTION_ASC = 'asc';
export const SORT_DIRECTION_DESC = 'desc';

export const UNSORTED_FOLDER = 'Unsorted';
export const TRASH_FOLDER = 'Trash';
export const MAX_SIZE = 1600;
export const VIEW_GRID = 'grid';
export const VIEW_LIST = 'list';
